const MIN = 11
const MAX = 21

function makePrice({ expected, side }) {
  const sum = 1 / parseFloat(expected.home) + 1 / parseFloat(expected.away)

  const sideValue = side === 0 ? expected.home : expected.away

  const value = (1 / parseFloat(sideValue)) / sum
  const price = MIN + value * (MAX - MIN)

  return parseFloat(price.toFixed(2))
}

export default {
  makePrice,
};
